<template>
  <div>
    <div class="mainbg p64">
      <div class="container">
        <CertContent :certContent='certInfo'>
          <div slot="handle">
             <button v-if="isApply == 2" class="Ai-btn ibtn-primary mr32"  @click="showApply = true">我要{{ this.$route.query.lang && this.$route.query.lang === 'cht' ? '報': '报'}}名</button>
             <button class="Ai-btn ibtn-default" @click="jumpTo(certInfo.id)">查看岗位课表</button>
          </div>
        </CertContent>
        <div class="border-bg border-arrow mb48"></div>
        <div class="whiteBg p32 mb40">
          <div class="text-center mb32">
            <div class="ft18 mb8"><b> 岗位认证介绍</b></div>
            <div class="color9">Introduction to post certification</div>
          </div>
          <div v-html="certInfo.content">
            {{certInfo.content}}
          </div>
        </div>
      </div>
    </div>
    <Apply :type="2" @showApply="handleShow" v-if="showApply" :certname='certInfo.title' />
  </div>
</template>

<script>
import { getattestDetailApi } from "./../../api/api"
import Apply from './../train/components/apply'
import CertContent from './../train/components/certContent'
import CourseList from './../public/courseList'
export default {
  name: "trainDetail",
  components:{
    Apply,
    CertContent,
    CourseList
  },
  data() {
    return {
      newId: this.$route.query.newId, //id
      certInfo:[],
      isApply: 1, //2为报名 1已报名
      showApply: false
    };
  },
  mounted() {
    this.GettrainDetail();
  },
  methods: {
    GettrainDetail() {
      //获取培训岗位列表
      const obj = {
        id: this.newId,
        lang: localStorage.getItem('lang')
      };
      getattestDetailApi(obj).then((res) => {
          if (res.data.code == 0) {
            const data = res.data.data
            this.certInfo = data.certDetail
            this.isApply = data.isApply
          } else {
            this.$message.warning(res.data.msg)
          }
        })
        .catch((err) => {
          this.$message.error(err)
        });
    },
    
    jumpTo(id) {
      //考试跳转
      this.$router.push({
        name: "trainCourse",
        query: {
          newId: id,
        },
      });
    },
    handleShow(){
      this.showApply = false
    }
  },
};
</script>

<style  scoped>
.p64 {
  padding: 64px 0px 40px;
}
.prosess{
  font-size: 0;
  display: inline-block;
  width: 240px;
  height: 10px;
  background: #eee;
  border-radius: 5px;
  overflow: hidden;
}
.prosess-body{
  display: inline-block;
  height: 10px;
  background: linear-gradient(90deg, #1EA2FF 0%, #4E71F8 100%);
}
</style>



// WEBPACK FOOTER //
// src/components/train/trainDetail.vue